// extracted by mini-css-extract-plugin
export default {"specialEventsCardImg":"SpecialEventsSection_specialEventsCardImg__dZV2F","specialEventsCardImgScaleddown":"SpecialEventsSection_specialEventsCardImgScaleddown__sWIwg"};